<!-- 柱状图配置 -->
<template>
  <div>
    <el-form-item label="竖展示">
      <el-switch v-model="main.activeOption.category" size="small"></el-switch>
    </el-form-item>
    <el-form-item label="双边展示">
      <el-switch v-model="main.activeOption.bothSide" size="small"></el-switch>
    </el-form-item>
    <el-form-item label="开启堆叠">
      <el-switch v-model="main.activeOption.stack" size="small"></el-switch>
    </el-form-item>
    <el-form-item label="翻转指标">
      <el-switch v-model="main.activeOption.overturn" size="small"></el-switch>
    </el-form-item>
    <el-form-item label="toolTip辅助指标" label-width="120px">
      <el-switch v-model="main.activeOption.assistTip" size="small"></el-switch>
    </el-form-item>
    <el-collapse accordion>
      <el-collapse-item title="柱体设置">
        <el-form-item label="最大宽度">
          <el-slider v-model="main.activeOption.barWidth">
          </el-slider>
        </el-form-item>
        <el-form-item label="圆角">
          <el-slider v-model="main.activeOption.barRadius">
          </el-slider>
        </el-form-item>
        <el-form-item label="最小高度">
          <el-slider v-model="main.activeOption.barMinHeight">
          </el-slider>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
    <PageConfig></PageConfig>
  </div>
</template>

<script>
import PageConfig from './page.vue'

export default {
  name: 'horizontalBar',
  inject: ["main"],
  components: {
    PageConfig
  }
}
</script>

<style>
</style>